import { useState } from "react";
import { ANNOUNCEMENT_REPLY_BODY_MAX } from "@edu/shared";
import { ApiError } from "../../lib/api.ts";
import { announcementErrorText } from "./announcement-text.ts";
import { addAnnouncementReply } from "./announcements-api.ts";

/**
 * Написать в открытое окно.
 *
 * ⚠️ **Своим файлом, а не куском окна** (правка по итогам итогового ревью
 * 30.08.2026, порог в 400 строк из раздела 9 CLAUDE.md). Форма ни одного
 * состояния окна не читает и не двигает: ей нужен адрес, куда класть слова, и
 * способ сказать «положила». Всё остальное в `ConversationPage.tsx` про
 * прокрутку, страницы и свежесть, то есть про другое.
 *
 * ⚠️ **Куда писать, называет СЕРВЕР** (`replyToId`). Ответ в схеме прикреплён к
 * объявлению, а не к разговору, и «самое свежее объявление» экран сам вывести не
 * может: при длинной переписке свежее объявление лежит за страницей, ниже
 * последних ответов.
 *
 * ⚠️ **Отказ `409 student_not_linked` остаётся возможен, и это не дублирование
 * проверки.** Состояние пары приезжает в шапке окна, поэтому у отвязанного формы
 * нет вовсе; но между чтением окна и нажатием пару можно отвязать, и тогда
 * человек читает отказ. Слова у обоих случаев ОДНИ (`REPLIES_CLOSED_TEXT`): одно
 * и то же событие не должно читаться как два разных.
 */
export function ConversationSendForm(props: { replyToId: string; onSent: () => void }) {
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  const text = body.trim();
  const send = (e: React.FormEvent) => {
    e.preventDefault();
    if (text === "" || busy) return;
    void (async () => {
      setBusy(true);
      setErr(null);
      try {
        await addAnnouncementReply(props.replyToId, text);
        setBody("");
        props.onSent();
      } catch (e2) {
        setErr(
          e2 instanceof ApiError
            ? announcementErrorText(e2.code, e2.message)
            : e2 instanceof Error
              ? e2.message
              : String(e2),
        );
      } finally {
        setBusy(false);
      }
    })();
  };

  return (
    <form className="form chat__form" onSubmit={send}>
      <label className="field">
        <span className="lbl">Сообщение</span>
        <textarea
          className="fld"
          rows={3}
          value={body}
          maxLength={ANNOUNCEMENT_REPLY_BODY_MAX}
          disabled={busy}
          onChange={(e) => setBody(e.target.value)}
        />
      </label>
      {err !== null && <p className="err">{err}</p>}
      <div className="form__foot">
        {/*
          Вес обычный, а не акцентный: на этом экране живёт необратимое
          (удаление), и акцент рядом с красным сделал бы красное неразличимым.
          Правило 3 блока весов кнопок в styles.css
        */}
        <button className="btn" type="submit" disabled={busy || text === ""}>
          {busy ? "Отправляем…" : "Отправить"}
        </button>
      </div>
    </form>
  );
}
